import { ClockIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { tChatEvent } from '../../../../../../Chat.types';
import { useScheduledDateFormat } from '../FollowUpBubble/FollowUpBubble.hook';
import { useSchedulerName } from './ScheduledLegend.hook';
import './ScheduledLegend.styles.scss';

export type tScheduledLegendProps = {
  /** The scheduled card the message came from. */
  followUp: tChatEvent;
  /** For a bubble that sets its own text colors instead of --bubble-accent. */
  className?: string;
};

/**
 * INT-1505: under a message that went out on a schedule, who scheduled it and
 * when they scheduled it — not when it was sent, which the header already says.
 */
export default function ScheduledLegend(props: tScheduledLegendProps) {
  const { followUp, className } = props;
  const { t } = useTranslation('chat/chat');
  const formatDate = useScheduledDateFormat();
  const name = useSchedulerName(followUp.createdBy);

  const isTemplate = Boolean(
    followUp.isWapiTemplate || followUp.followUp?.campaignId != null,
  );
  const key = isTemplate ? 'legendTemplate' : 'legendMessage';
  const date = formatDate(followUp.createdAt);

  return (
    <p
      className={classNames('ScheduledLegend', className)}
      data-testid="scheduled-legend"
    >
      <ClockIcon className="ScheduledLegend__Icon" aria-hidden="true" />
      <span>
        {name
          ? t(`scheduledMessage.${key}`, { name, date })
          : t(`scheduledMessage.${key}NoName`, { date })}
      </span>
    </p>
  );
}
